(() => {
  if (window.MezkuiFitTabs) return;
  window.MezkuiFitTabs = true;

  const activate = (tabs, name, focus = false) => {
    const selected = tabs.querySelector(`[data-mezkui-fit-tab="${name}"]`);
    if (!selected) return;
    tabs.querySelectorAll('[data-mezkui-fit-tab]').forEach((tab) => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    tabs.querySelectorAll('[data-mezkui-fit-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.mezkuiFitPanel !== name;
    });
    if (focus) selected.focus();
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-mezkui-fit-tabs]').forEach((tabs) => {
      if (tabs.dataset.mezkuiFitTabsReady) return;
      tabs.dataset.mezkuiFitTabsReady = 'true';
      activate(tabs, 'measure');
    });
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-mezkui-fit-tab]');
    if (!tab) return;
    const tabs = tab.closest('[data-mezkui-fit-tabs]');
    if (tabs) activate(tabs, tab.dataset.mezkuiFitTab);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-mezkui-fit-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = tab.closest('[data-mezkui-fit-tabs]');
    if (!tabs) return;
    const choices = [...tabs.querySelectorAll('[data-mezkui-fit-tab]')];
    const index = choices.indexOf(tab);
    const next = event.key === 'Home' ? 0
      : event.key === 'End' ? choices.length - 1
      : (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
    event.preventDefault();
    activate(tabs, choices[next].dataset.mezkuiFitTab, true);
  });

  const observe = () => {
    initialize();
    new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList')) initialize();
      records.forEach((record) => {
        if (record.type === 'attributes' && record.attributeName === 'open' && record.target.matches('dialog[open]')) {
          record.target.querySelectorAll('[data-mezkui-fit-tabs]').forEach((tabs) => activate(tabs, 'measure'));
        }
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open'] });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
